module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style",
    attrs: {
      "id": "fm-13-unmoldingicepops-text"
    }
  }, [_c('p', {
    staticClass: "top-bar",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style-2"
  }, [_c('img', {
    staticClass: "generated-style-2",
    attrs: {
      "alt": "IcePops_TopBar_Orange.gif",
      "src": "Images/IcePops_TopBar_Orange_fmt2.jpeg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "unmolding-ice-pops-anchor"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "recipe-heading",
    attrs: {
      "id": "toc-anchor",
      "xml:lang": "en-us"
    }
  }, [_vm._v("unmolding ice pops")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("There are two common anxieties when making ice pops: that the pops will get stuck in the molds, or that the sticks will slip out or freeze in an awkward position. Follow these steps for perfect ice pops every time.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_vm._v("cooling")])]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Cool custards and other heated mixtures over an ice bath before pouring into the molds. Fill a large bowl half full with ice and water. Nestle a smaller heatproof bowl inside. Strain the hot mixture into the small bowl and let the mixture cool, stirring, until cool.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_vm._v("freezing")])]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Unless your ice pop molds contain tops that hold the sticks securely throughout the freezing process, insert the sticks when the pops are partially frozen to ensure proper placement. Also, always let your ice pops freeze until completely solid before removing them—if they’re not completely frozen at the center, you might lose the stick when unmolding.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_vm._v("unmolding")])]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Let the ice pops stand on the counter for 3 to 5 minutes. If necessary, run the mold under warm running water to slightly melt the pops and release from the molds.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_vm._v("Get Creative")])]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Look beyond traditional molds and wooden sticks to have even more fun with ice pops!")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Freeze ice pops in small juice glasses, silicone cupcake cups, madeleine pans, or other common kitchen items.")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Use a variety of “sticks,” such as decorative straws, bamboo skewers, or cinnamon sticks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Use edible sticks, such as pretzel rods, chocolate-dipped rolled wafer cookies, or biscotti.")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Follow the manufacturer’s instructions for using sticks when using an instant pop maker.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH02_06_DoubleChocolateSwirl_ePub_text",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("double chocolate swirl ice pops")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingredients",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH02_07_ChocolateTruffleChunk_ePub_text",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chocolate truffle chunk ice pops")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingredients",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH03_07_RootBeerCream_ePub_text",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("root beer cream ice pops")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingredients",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH03_15_CaramelAlmond_ePub_text",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("caramel-almond ice pops")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingredients",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "bold-link"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH03_16_VanillaToffeeChip_ePub_text",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vanilla–toffee chip ice pops")])])]), _vm._v(" "), _c('p', {
    staticClass: "bottom-bar",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style-2"
  }, [_c('img', {
    staticClass: "generated-style-2",
    attrs: {
      "alt": "IcePops_TopBar_Orange.gif",
      "src": "Images/IcePops_TopBar_Orange_fmt3.jpeg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51173059","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FM_13_UnmoldingIcePops_text.vue
// module id = 81
// module chunks = 0